import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const importProductSezinfoApi = createApi({
    reducerPath: "importProductSezinfo",
    baseQuery,
    tagTypes: ["importProductSezinfo"],
    endpoints: (builder) => ({
     
        createImportProductSez: builder.mutation({
            query: ({ id,...data }) => ({
              url: `import/sezInfo/${id}`, 
              method: "PUT",
              headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
              body: { sez:data },
            }),
            invalidatesTags: ["importProductSezinfo"],
          }),

            getSezInfoId: builder.query({
                query: ({id}) => `import/sezInfo/${id}`,
                transformResponse: (response) => 
                {
                    const data= response?.data ;
                    const normalized = Array.isArray(data) ? data : [data];
                    return normalized.map((item,index) => ({
                    ...item,
                    SrNo:index+1,
                    id: item.sezInfoId, // 👈 use backend's exportEntityId
                    }));

                },
                providesTags: ["importProductSezinfo"],
            }), 
            updateProductSez: builder.mutation({
                query: ({ id, subId, ...data }) => ({
                  url: `import/sezInfo/${id}/${subId}`,
                  method: "PUT",
                  body: { sez: data },
                }),
                invalidatesTags: ["importProductSezinfo"],
              }),
    
              deleteProductSez: builder.mutation({
                query: ({ id}) => {
                  return {
                    url: `import/sezInfo/${id}`,
                    method: "DELETE",
                  };
                },
                invalidatesTags: ["importProductSezinfo"],
              }),
    
            






        }),

    })
    export const {
       useCreateImportProductSezMutation,
       //getSezInfoId
       useLazyGetSezInfoIdQuery,
       
       useUpdateProductSezMutation,
   
       useDeleteProductSezMutation
       
        
  
        } = importProductSezinfoApi;

